import equal from 'fast-deep-equal';

import { FILTERS_STORAGE_ROOT_KEY } from './clearFiltersStorage';

// Читает сохранённые фильтры по корневому ключу
function readRootMap(): Record<string, Record<string, unknown>> {
  try {
    const raw = localStorage.getItem(FILTERS_STORAGE_ROOT_KEY);
    if (!raw) return {};
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
      return parsed as Record<string, Record<string, unknown>>;
    }
    return {};
  } catch {
    return {};
  }
}

// Пишет фильтры в корневой объект localStorage; при совпадении с дефолтами —
// удаляет запись контекста, опустевшую карту — удаляет целиком
export function saveFiltersToStorage(
  storageKey: string,
  appliedFilters: Record<string, unknown>,
  defaultFilters: Record<string, unknown>,
): void {
  try {
    const rootMap = readRootMap();
    if (equal(appliedFilters, defaultFilters)) {
      delete rootMap[storageKey];
    } else {
      rootMap[storageKey] = appliedFilters;
    }

    if (Object.keys(rootMap).length === 0) {
      localStorage.removeItem(FILTERS_STORAGE_ROOT_KEY);
    } else {
      localStorage.setItem(FILTERS_STORAGE_ROOT_KEY, JSON.stringify(rootMap));
    }
  } catch (error) {
    console.warn(`Failed to save filters in localStorage (key: ${storageKey})`, error);
  }
}
